export default "__VITE_ASSET__BYmgO1Gb__"